import { Node } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

export type TPrompt = {
  prompt: string
  isHighlighted: boolean
}

export function getPrompt({ editor }: { editor: BufferEditor }): TPrompt {
  const texts = editor.children?.map((node) => {
    return node.type === 'p' ? `${Node.string(node)}` : ''
  })

  const highlighted = editor.selection
    ? editor.api.string(editor.selection)
    : null

  const prompt = highlighted ? highlighted.trim() : texts.join(' ').trim()

  return { prompt, isHighlighted: !!highlighted }
}
